import { LightningElement, api, wire } from "lwc";
import LabelsAdapter, { unflattenObject } from "i18n/labelsAdapter";
import {
  L as LANGUAGE_LABEL_MAP,
  g as getLanguage,
  s as setLanguage,
} from "wes/chunk_countryOptions";
import { ClientLogger } from "common/clientLogger";
import "wes/chunk_commonjsHelpers";

var copyright$i =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Alle rettigheder forbeholdes</a>. Forskellige varemærker tilhører deres respektive ejere.";
var legal$i = "Juridisk";
var privacyStatement$i = "Oplysninger om beskyttelse af personlige oplysninger";
var responsibleDisclosure$i = "Ansvarlig offentliggørelse";
var termsOfUse$i = "Vilkår for anvendelse";
var trust$i = "Trust";
var help$i = "Hjælp";
var contact$i = "Kontakt";
var cookiePreferences$i = "Cookie-præferencer";
var privacyChoices$i = "Dine valg for beskyttelse af personlige oplysninger";
var errorToast$i =
  "Vi kunne ikke opdatere sproget på din profil. Opdater siden, og prøv igen.";
var da = {
  copyright: copyright$i,
  legal: legal$i,
  privacyStatement: privacyStatement$i,
  responsibleDisclosure: responsibleDisclosure$i,
  termsOfUse: termsOfUse$i,
  trust: trust$i,
  help: help$i,
  contact: contact$i,
  cookiePreferences: cookiePreferences$i,
  privacyChoices: privacyChoices$i,
  errorToast: errorToast$i,
};

var copyright$h =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Alle Rechte vorbehalten</a>. Die verschiedenen Marken sind Eigentum der jeweiligen Inhaber.";
var legal$h = "Rechtliches";
var privacyStatement$h = "Datenschutzinformationen";
var responsibleDisclosure$h = "Verantwortungsvolle Offenlegung";
var termsOfUse$h = "Nutzungsbedingungen";
var trust$h = "Trust";
var help$h = "Hilfe";
var contact$h = "Kontakt";
var cookiePreferences$h = "Cookie-Voreinstellungen";
var privacyChoices$h = "Ihre Datenschutzentscheidungen";
var errorToast$h =
  "Wir konnten die Sprache in Ihrem Profil nicht ändern. Aktualisieren Sie die Seite und versuchen Sie es erneut.";
var de = {
  copyright: copyright$h,
  legal: legal$h,
  privacyStatement: privacyStatement$h,
  responsibleDisclosure: responsibleDisclosure$h,
  termsOfUse: termsOfUse$h,
  trust: trust$h,
  help: help$h,
  contact: contact$h,
  cookiePreferences: cookiePreferences$h,
  privacyChoices: privacyChoices$h,
  errorToast: errorToast$h,
};

var copyright$g =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>All rights reserved</a>. Various trademarks held by their respective owners.";
var legal$g = "Legal";
var privacyStatement$g = "Privacy Information";
var responsibleDisclosure$g = "Responsible Disclosure";
var termsOfUse$g = "Terms of Use";
var trust$g = "Trust";
var help$g = "Help";
var contact$g = "Contact";
var cookiePreferences$g = "Cookie Preferences";
var privacyChoices$g = "Your Privacy Choices";
var errorToast$g =
  "We were not able to update the language on your profile. Refresh the page and try again.";
var en = {
  copyright: copyright$g,
  legal: legal$g,
  privacyStatement: privacyStatement$g,
  responsibleDisclosure: responsibleDisclosure$g,
  termsOfUse: termsOfUse$g,
  trust: trust$g,
  help: help$g,
  contact: contact$g,
  cookiePreferences: cookiePreferences$g,
  privacyChoices: privacyChoices$g,
  errorToast: errorToast$g,
};

var copyright$f =
  "[© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>All rights reserved</a>. Various trademarks held by their respective owners.]'介引户הаí 先ร简 аน取정úσι мÜП介мのα şแةбй 계]";
var legal$f = "[Legal]'介引户]";
var privacyStatement$f = "[Privacy Information]'介引户הа]";
var responsibleDisclosure$f = "[Responsible Disclosure]'介引户הа]";
var termsOfUse$f = "[Terms of Use]'介引户הа]";
var trust$f = "[Trust]'介引户הа]";
var help$f = "[Help]'介引户]";
var contact$f = "[Contact]'介引户הаí]";
var cookiePreferences$f = "[Cookie Preferences]'介引户הаí]";
var privacyChoices$f = "[Your Privacy Choices]'介引户הаí ]";
var errorToast$f =
  "[We were not able to update the language on your profile. Refresh the page and try again.]'介引户הаí 先ร简 аน取정úσι мÜП介мのα şแةбй 계]";
var eo = {
  copyright: copyright$f,
  legal: legal$f,
  privacyStatement: privacyStatement$f,
  responsibleDisclosure: responsibleDisclosure$f,
  termsOfUse: termsOfUse$f,
  trust: trust$f,
  help: help$f,
  contact: contact$f,
  cookiePreferences: cookiePreferences$f,
  privacyChoices: privacyChoices$f,
  errorToast: errorToast$f,
};

var copyright$e =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Todos los derechos reservados</a>. Las diversas marcas comerciales son propiedad de sus respectivos propietarios.";
var legal$e = "Aviso legal";
var privacyStatement$e = "Información de privacidad";
var responsibleDisclosure$e = "Revelación responsable";
var termsOfUse$e = "Condiciones de uso";
var trust$e = "Trust";
var help$e = "Ayuda";
var contact$e = "Contacto";
var cookiePreferences$e = "Preferencias de cookies";
var privacyChoices$e = "Sus opciones de privacidad";
var errorToast$e =
  "No hemos podido actualizar el idioma de su perfil. Actualice la página e inténtelo de nuevo.";
var es = {
  copyright: copyright$e,
  legal: legal$e,
  privacyStatement: privacyStatement$e,
  responsibleDisclosure: responsibleDisclosure$e,
  termsOfUse: termsOfUse$e,
  trust: trust$e,
  help: help$e,
  contact: contact$e,
  cookiePreferences: cookiePreferences$e,
  privacyChoices: privacyChoices$e,
  errorToast: errorToast$e,
};

var copyright$d =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Reservados todos los derechos</a>. Las diversas marcas comerciales son propiedad de sus respectivos propietarios.";
var legal$d = "Legal";
var privacyStatement$d = "Información sobre la privacidad";
var responsibleDisclosure$d = "Divulgación responsable";
var termsOfUse$d = "Condiciones de uso";
var trust$d = "Trust";
var help$d = "Ayuda";
var contact$d = "Contacto";
var cookiePreferences$d = "Preferencias de cookies";
var privacyChoices$d = "Sus elecciones de privacidad";
var errorToast$d =
  "No pudimos actualizar el idioma de su perfil. Actualice la página e inténtelo de nuevo.";
var esMX = {
  copyright: copyright$d,
  legal: legal$d,
  privacyStatement: privacyStatement$d,
  responsibleDisclosure: responsibleDisclosure$d,
  termsOfUse: termsOfUse$d,
  trust: trust$d,
  help: help$d,
  contact: contact$d,
  cookiePreferences: cookiePreferences$d,
  privacyChoices: privacyChoices$d,
  errorToast: errorToast$d,
};

var copyright$c =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Kaikki oikeudet pidätetään</a>. Eri tavaramerkit ovat vastaavien omistajien omaisuutta.";
var legal$c = "Lakisääteinen";
var privacyStatement$c = "Tietosuojatiedot";
var responsibleDisclosure$c = "Vastuullinen tiedonantokäytäntö";
var termsOfUse$c = "Käyttöehdot";
var trust$c = "Trust";
var help$c = "Ohje";
var contact$c = "Ota yhteyttä";
var cookiePreferences$c = "Evästeasetukset";
var privacyChoices$c = "Tietosuojavalintasi";
var errorToast$c =
  "Emme voineet päivittää profiilisi kieltä. Päivitä sivu ja yritä uudelleen.";
var fi = {
  copyright: copyright$c,
  legal: legal$c,
  privacyStatement: privacyStatement$c,
  responsibleDisclosure: responsibleDisclosure$c,
  termsOfUse: termsOfUse$c,
  trust: trust$c,
  help: help$c,
  contact: contact$c,
  cookiePreferences: cookiePreferences$c,
  privacyChoices: privacyChoices$c,
  errorToast: errorToast$c,
};

var copyright$b =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Tous droits réservés</a>. Diverses marques de commerce détenues par leurs propriétaires respectifs.";
var legal$b = "Informations juridiques";
var privacyStatement$b = "Confidentialité";
var responsibleDisclosure$b = "Divulgation responsable";
var termsOfUse$b = "Conditions d’utilisation";
var trust$b = "Trust";
var help$b = "Aide";
var contact$b = "Contact";
var cookiePreferences$b = "Préférences en matière de cookies";
var privacyChoices$b = "Vos choix de confidentialité";
var errorToast$b =
  "Impossible de mettre à jour la langue de votre profil. Actualisez la page, puis réessayez.";
var fr = {
  copyright: copyright$b,
  legal: legal$b,
  privacyStatement: privacyStatement$b,
  responsibleDisclosure: responsibleDisclosure$b,
  termsOfUse: termsOfUse$b,
  trust: trust$b,
  help: help$b,
  contact: contact$b,
  cookiePreferences: cookiePreferences$b,
  privacyChoices: privacyChoices$b,
  errorToast: errorToast$b,
};

var copyright$a =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Tutti i diritti riservati</a>. Vari marchi di proprietà dei rispettivi titolari.";
var legal$a = "Note legali";
var privacyStatement$a = "Informazioni sulla privacy";
var responsibleDisclosure$a = "Responsible Disclosure";
var termsOfUse$a = "Condizioni di utilizzo";
var trust$a = "Trust";
var help$a = "Guida";
var contact$a = "Contattaci";
var cookiePreferences$a = "Preferenze per i cookie";
var privacyChoices$a = "Le tue scelte relative alla privacy";
var errorToast$a =
  "Non siamo riusciti ad aggiornare la lingua sul tuo profilo. Aggiorna la pagina e riprova.";
var it = {
  copyright: copyright$a,
  legal: legal$a,
  privacyStatement: privacyStatement$a,
  responsibleDisclosure: responsibleDisclosure$a,
  termsOfUse: termsOfUse$a,
  trust: trust$a,
  help: help$a,
  contact: contact$a,
  cookiePreferences: cookiePreferences$a,
  privacyChoices: privacyChoices$a,
  errorToast: errorToast$a,
};

var copyright$9 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>All rights reserved</a>. それぞれの商標は、それぞれの商標所有者に帰属します。";
var legal$9 = "法務";
var privacyStatement$9 = "プライバシー情報";
var responsibleDisclosure$9 = "責任ある開示";
var termsOfUse$9 = "利用規約";
var trust$9 = "Trust";
var help$9 = "ヘルプ";
var contact$9 = "連絡先";
var cookiePreferences$9 = "Cookie の設定";
var privacyChoices$9 = "プライバシーの選択肢";
var errorToast$9 =
  "プロファイルの言語を更新することができませんでした。ページを更新してもう一度お試しください。";
var ja = {
  copyright: copyright$9,
  legal: legal$9,
  privacyStatement: privacyStatement$9,
  responsibleDisclosure: responsibleDisclosure$9,
  termsOfUse: termsOfUse$9,
  trust: trust$9,
  help: help$9,
  contact: contact$9,
  cookiePreferences: cookiePreferences$9,
  privacyChoices: privacyChoices$9,
  errorToast: errorToast$9,
};

var copyright$8 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>All rights reserved</a>. 해당 소유자가 보유한 다양한 상표가 있습니다.";
var legal$8 = "법률";
var privacyStatement$8 = "개인정보보호 정보";
var responsibleDisclosure$8 = "책임감 있는 공개";
var termsOfUse$8 = "사용 약관";
var trust$8 = "Trust";
var help$8 = "도움말";
var contact$8 = "연락처";
var cookiePreferences$8 = "쿠키 설정";
var privacyChoices$8 = "개인정보보호 선택권";
var errorToast$8 =
  "프로필의 언어를 업데이트하지 못했습니다. 페이지를 새로 고침한 후 다시 시도하세요.";
var ko = {
  copyright: copyright$8,
  legal: legal$8,
  privacyStatement: privacyStatement$8,
  responsibleDisclosure: responsibleDisclosure$8,
  termsOfUse: termsOfUse$8,
  trust: trust$8,
  help: help$8,
  contact: contact$8,
  cookiePreferences: cookiePreferences$8,
  privacyChoices: privacyChoices$8,
  errorToast: errorToast$8,
};

var copyright$7 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Alle rechten voorbehouden</a>. De diverse handelsmerken zijn eigendom van hun respectieve eigenaars.";
var legal$7 = "Wettelijk";
var privacyStatement$7 = "Privacy-informatie";
var responsibleDisclosure$7 = "Verantwoorde openbaarmaking";
var termsOfUse$7 = "Gebruiksvoorwaarden";
var trust$7 = "Trust";
var help$7 = "Help";
var contact$7 = "Neem contact op met";
var cookiePreferences$7 = "Cookievoorkeuren";
var privacyChoices$7 = "Uw privacykeuzes";
var errorToast$7 =
  "We kunnen de taal in uw profiel niet bijwerken. Vernieuw de pagina en probeer het opnieuw.";
var nl = {
  copyright: copyright$7,
  legal: legal$7,
  privacyStatement: privacyStatement$7,
  responsibleDisclosure: responsibleDisclosure$7,
  termsOfUse: termsOfUse$7,
  trust: trust$7,
  help: help$7,
  contact: contact$7,
  cookiePreferences: cookiePreferences$7,
  privacyChoices: privacyChoices$7,
  errorToast: errorToast$7,
};

var copyright$6 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Med enerett</a>. Ulike varemerker er eiendommen til de respektive innehaverne.";
var legal$6 = "Juridisk";
var privacyStatement$6 = "Informasjon om personvern";
var responsibleDisclosure$6 = "Ansvarlig videreformidling";
var termsOfUse$6 = "Vilkår for bruk";
var trust$6 = "Trust";
var help$6 = "Hjelp";
var contact$6 = "Kontakt";
var cookiePreferences$6 = "Preferanser for informasjonskapsler";
var privacyChoices$6 = "Dine personvernvalg";
var errorToast$6 =
  "Vi kunne ikke oppdatere språket i profilen din. Oppdater siden og prøv på nytt.";
var no = {
  copyright: copyright$6,
  legal: legal$6,
  privacyStatement: privacyStatement$6,
  responsibleDisclosure: responsibleDisclosure$6,
  termsOfUse: termsOfUse$6,
  trust: trust$6,
  help: help$6,
  contact: contact$6,
  cookiePreferences: cookiePreferences$6,
  privacyChoices: privacyChoices$6,
  errorToast: errorToast$6,
};

var copyright$5 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Todos os direitos reservados</a>. As diversas marcas comerciais pertencem aos respectivos proprietários.";
var legal$5 = "Informações legais";
var privacyStatement$5 = "Informações sobre privacidade";
var responsibleDisclosure$5 = "Divulgação responsável";
var termsOfUse$5 = "Termos de uso";
var trust$5 = "Trust";
var help$5 = "Ajuda";
var contact$5 = "Contato";
var cookiePreferences$5 = "Preferências de cookies";
var privacyChoices$5 = "Suas escolhas de privacidade";
var errorToast$5 =
  "Não foi possível atualizar o idioma do seu perfil. Atualize a página e tente novamente.";
var ptBR = {
  copyright: copyright$5,
  legal: legal$5,
  privacyStatement: privacyStatement$5,
  responsibleDisclosure: responsibleDisclosure$5,
  termsOfUse: termsOfUse$5,
  trust: trust$5,
  help: help$5,
  contact: contact$5,
  cookiePreferences: cookiePreferences$5,
  privacyChoices: privacyChoices$5,
  errorToast: errorToast$5,
};

var copyright$4 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Все права защищены</a>. Упомянутые товарные знаки принадлежат соответствующим владельцам.";
var legal$4 = "Правовая информация";
var privacyStatement$4 = "Сведения о конфиденциальности";
var responsibleDisclosure$4 = "Ответственное раскрытие информации";
var termsOfUse$4 = "Условия использования";
var trust$4 = "Доверие";
var help$4 = "Справка";
var contact$4 = "Контакты";
var cookiePreferences$4 = "Параметры cookie-файлов";
var privacyChoices$4 = "Ваш выбор конфиденциальности";
var errorToast$4 =
  "Не удалось обновить язык в профиле. Обновите страницу и повторите попытку.";
var ru = {
  copyright: copyright$4,
  legal: legal$4,
  privacyStatement: privacyStatement$4,
  responsibleDisclosure: responsibleDisclosure$4,
  termsOfUse: termsOfUse$4,
  trust: trust$4,
  help: help$4,
  contact: contact$4,
  cookiePreferences: cookiePreferences$4,
  privacyChoices: privacyChoices$4,
  errorToast: errorToast$4,
};

var copyright$3 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>Alla rättigheter förbehållna</a>. Olika varumärken tillhör sina respektive ägare.";
var legal$3 = "Juridiskt";
var privacyStatement$3 = "Sekretessinformation";
var responsibleDisclosure$3 = "Ansvarsfullt offentliggörande";
var termsOfUse$3 = "Användningsvillkor";
var trust$3 = "Trust";
var help$3 = "Hjälp";
var contact$3 = "Kontakt";
var cookiePreferences$3 = "Cookie-preferenser";
var privacyChoices$3 = "Dina integritetsalternativ";
var errorToast$3 =
  "Vi kunde inte uppdatera språket i din profil. Uppdatera sidan och försök igen.";
var sv = {
  copyright: copyright$3,
  legal: legal$3,
  privacyStatement: privacyStatement$3,
  responsibleDisclosure: responsibleDisclosure$3,
  termsOfUse: termsOfUse$3,
  trust: trust$3,
  help: help$3,
  contact: contact$3,
  cookiePreferences: cookiePreferences$3,
  privacyChoices: privacyChoices$3,
  errorToast: errorToast$3,
};

var copyright$2 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>สงวนลิขสิทธิ์</a> เครื่องหมายการค้าต่าง ๆ เป็นของเจ้าของเครื่องหมายการค้านั้น ๆ";
var legal$2 = "กฎหมาย";
var privacyStatement$2 = "ข้อมูลความเป็นส่วนตัว";
var responsibleDisclosure$2 = "การเปิดเผยข้อมูลอย่างมีความรับผิดชอบ";
var termsOfUse$2 = "ข้อกำหนดการใช้งาน";
var trust$2 = "Trust";
var help$2 = "วิธีใช้";
var contact$2 = "ติดต่อ";
var cookiePreferences$2 = "การกำหนดลักษณะของคุกกี้";
var privacyChoices$2 = "ตัวเลือกความเป็นส่วนตัวของคุณ";
var errorToast$2 =
  "เราไม่สามารถอัปเดตภาษาบนโพรไฟล์ของคุณ รีเฟรชหน้าแล้วลองอีกครั้ง";
var th = {
  copyright: copyright$2,
  legal: legal$2,
  privacyStatement: privacyStatement$2,
  responsibleDisclosure: responsibleDisclosure$2,
  termsOfUse: termsOfUse$2,
  trust: trust$2,
  help: help$2,
  contact: contact$2,
  cookiePreferences: cookiePreferences$2,
  privacyChoices: privacyChoices$2,
  errorToast: errorToast$2,
};

var copyright$1 =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>保留所有权利</a>。其他各商标均为其各自的所有人所有。";
var legal$1 = "法律";
var privacyStatement$1 = "隐私信息";
var responsibleDisclosure$1 = "责任披露";
var termsOfUse$1 = "使用条款";
var trust$1 = "Trust";
var help$1 = "帮助";
var contact$1 = "联系人";
var cookiePreferences$1 = "Cookie 首选项";
var privacyChoices$1 = "您的隐私选择";
var errorToast$1 = "我们无法更新您的简档语言。请刷新页面，并重试。";
var zhCN = {
  copyright: copyright$1,
  legal: legal$1,
  privacyStatement: privacyStatement$1,
  responsibleDisclosure: responsibleDisclosure$1,
  termsOfUse: termsOfUse$1,
  trust: trust$1,
  help: help$1,
  contact: contact$1,
  cookiePreferences: cookiePreferences$1,
  privacyChoices: privacyChoices$1,
  errorToast: errorToast$1,
};

var copyright =
  "© %{year}, %{companyName} <a href='%{hrefAllRightsReserved}' target='_blank' rel='noopener'>保留所有權利</a>。各種商標由其各自擁有者所持有。";
var legal = "法律";
var privacyStatement = "隱私群資訊";
var responsibleDisclosure = "負責任的披露";
var termsOfUse = "使用條款";
var trust = "Trust";
var help = "說明";
var contact = "連絡人";
var cookiePreferences = "Cookie 偏好設定";
var privacyChoices = "您的隱私權選擇";
var errorToast = "我們無法更新您設定檔上的語言。請重新整理頁面並再試一次。";
var zhTW = {
  copyright: copyright,
  legal: legal,
  privacyStatement: privacyStatement,
  responsibleDisclosure: responsibleDisclosure,
  termsOfUse: termsOfUse,
  trust: trust,
  help: help,
  contact: contact,
  cookiePreferences: cookiePreferences,
  privacyChoices: privacyChoices,
  errorToast: errorToast,
};

var componentLocales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  da: da,
  de: de,
  en: en,
  eo: eo,
  es: es,
  esMX: esMX,
  fi: fi,
  fr: fr,
  it: it,
  ja: ja,
  ko: ko,
  nl: nl,
  no: no,
  ptBR: ptBR,
  ru: ru,
  sv: sv,
  th: th,
  zhCN: zhCN,
  zhTW: zhTW,
});

async function loadGdpr() {
  // TODO: Handle waiting for initial import to load
  try {
    const gdpr = await import(
      "https://a.sfdcstatic.com/digital/one-trust/ext/v1-stable/gdpr.js"
    );
    await gdpr.onGdprReady;
    return gdpr;
  } catch (e) {
    console.error(e);
  }
}

const SUPPORTED_LOCALE_OPTIONS = Object.keys(LANGUAGE_LABEL_MAP).map(
  (langTag) => ({
    value: langTag,
    text: LANGUAGE_LABEL_MAP[langTag],
  }),
);
const getLocaleOptions = (env) => {
  return SUPPORTED_LOCALE_OPTIONS.filter((locale) => {
    return locale.value !== "eo" || env === "DEV" || env === "QA"; // In dev and qa return everything, all other environments filter out eo
  });
};

class footer extends LightningElement {
  companyName = "Salesforce, Inc.";
  @wire(ClientLogger)
  log = console.log;
  @api selectedLanguage = getLanguage();
  get env() {
    return window?.sfdcBase?.env;
  }

  // If true will reload the page after setting the locale
  @api localePageReload = false;
  labels = {
    component: {},
  };
  get languages() {
    return getLocaleOptions(this.env);
  }
  get copyright() {
    const copyrightLabel = this.labels?.component?.copyright || "";
    return `${copyrightLabel} ${this.companyName} Salesforce Tower, 415 Mission Street, 3rd Floor, San Francisco, CA 94105, United States`;
  }
  get imageUrl() {
    return window.location.hostname.includes("localhost")
      ? "/assets/img/privacychoices.svg"
      : "https://a.sfdcstatic.com/digital/@sfdc-www/wes-lwc-components/v1-stable/assets/img/privacychoices.svg";
  }
  async connectedCallback() {
    this.gdpr = await loadGdpr();
    setLanguage(this.selectedLanguage);
  }
  async onSelectLocale(e) {
    this.selectedLanguage = e.detail;
    setLanguage(this.selectedLanguage);
    this.gdpr?.setCookie(
      "locale",
      this.selectedLanguage,
      0,
      null,
      ".salesforce.com",
    );
    this.dispatchEvent(
      new CustomEvent("languageselection", {
        detail: this.selectedLanguage,
      }),
    );
    // Some pages (profile) need to be refreshed in order for the locale to fully take effect
    if (this.localePageReload) {
      location.reload();
    }
  }
  cookiePreferencesClicked() {
    window.OneTrust?.ToggleInfoDisplay();
  }
  get componentLabelOptions() {
    return {
      copyright: {
        year: `${new Date().getFullYear()}`,
        companyName: this.companyName,
        hrefAllRightsReserved:
          "https://www.salesforce.com/company/legal/intellectual/",
      },
    };
  }
  @wire(LabelsAdapter, {
    locales: componentLocales,
    options: "$componentLabelOptions",
  })
  handleComponentLabels(labels) {
    if (Object.keys(labels).length > 0) {
      this.labels = {
        ...this.labels,
        component: {
          ...unflattenObject(labels),
        },
      };
    }
  }
}

export default footer;
